import React from "react";
import { Container, Row, Col } from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import StackedTitle from "./layout/StackedTitle";

const banner = {
  background: "/content/private.png",
  Title: "INVESTMENT",
  childTitle: "HERITAGE WEALTH",
  desktopCol: "8",
};

const titleGroups = [
  [
    { text: "FAMILY OFFICE FUND" },
    { text: "WEALTH PLANNING & ", tone: "accent" },
    { text: "LEGACY SOLUTIONS" },
  ]
];

const intro = {
  title: "PRESERVING WEALTH. STRUCTURING LEGACY. INVESTING ACROSS GENERATIONS",
  paragraphs: [
    "HMG supports global families, entrepreneurs, and private investors in structuring, preserving, and growing multigenerational wealth through integrated family office planning and cross-border investment solutions.",
    "Our Global Heritage platform brings together strategic asset allocation, succession and legacy planning, private-market access, and professionally administered investment structures. Working alongside licensed financial, legal, tax, and fiduciary partners, we help families coordinate capital across jurisdictions while strengthening governance, continuity, and long-term value creation.",
  ],
};

const capabilities = {
  title: "CORE CAPABILITIES",
  items: [
    "Family Office Strategy & Wealth Structuring",
    "Global Heritage Family Office Fund",
    "Succession, Legacy & Governance Planning",
    "Cross-Border Investment Coordination",
    "Private Markets & Co-Investment Access",
    "Strategic Asset Allocation",
    "Next-Generation Wealth Continuity",
    "Coordination with Licensed Professional Partners",
  ],
};

class FamilyOffice extends React.Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const isMobile = this.state.width <= 500;
    const style = isMobile ? "pt-sm section-components" : "section section-components";

    return (
      <>
        <DemoNavbar />
        <main className="investment investment-family-office-page">
          <ChildPageBanner banner={banner} />
          <section className={style}>
            <Container>
              <section className="section-nucleo-icons">
                <Row className="align-items-top row-grid">
                  <Col md="5">
                    <StackedTitle groups={titleGroups} />
                  </Col>
                  <Col md="7">
                    <div>
                      <h1 className="home-child-title-body">{intro.title}</h1>
                      {intro.paragraphs.map(paragraph => (
                        <p className="description-Normal" key={paragraph.slice(0, 40)}>
                          {paragraph}
                        </p>
                      ))}
                      <p className="description-Normal">
                        Through the <strong>Global Heritage Family Office Fund</strong>, eligible
                        investors may access diversified investment opportunities across private
                        capital, infrastructure, real assets, technology, and other strategic growth
                        sectors—within structures designed to support disciplined investment,
                        institutional oversight, and enduring family wealth.
                      </p>
                      <p className="description-Italic">
                        “We do more than manage wealth—we preserve its purpose, protect its legacy, and carry it forward across generations.”
                      </p>
                    </div>
                    <div>
                      <h2 className="mt-5 home-child-title-body">{capabilities.title}</h2>
                      <div className="mt-4 description-Normal">
                        <ul>
                          {capabilities.items.map(item => (
                            <li key={item}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </Col>
                </Row>
              </section>
            </Container>
          </section>
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default FamilyOffice;
